var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('label', {
    staticClass: "Polaris-Label__Text",
    attrs: {
      "id": _vm.id + 'Label',
      "for": _vm.id
    }
  }, [(!_vm.$slots.children) ? _vm._t("default", [_vm._v(_vm._s(_vm.children))]) : _vm._e(), _vm._v(" "), _vm._t("children")], 2)])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-464697a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-464697a5","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PolarisLabel.vue
// module id = 289
// module chunks = 0